module.exports = __webpack_public_path__ + "static/img/4areaB_15.0b74e8e.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/4areaB_15.png
// module id = 1188
// module chunks = 1